import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/icons/Success.png'
import _imports_1 from '@/assets/images/icons/Fail.png'


const _hoisted_1 = { class: "invoice-popup-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "invoice-popup-wrapper__mask" }, null, -1)
const _hoisted_3 = { class: "invoice-popup-container" }
const _hoisted_4 = { class: "invoice-popup" }
const _hoisted_5 = {
  key: 0,
  class: "invoice-popup__icon"
}
const _hoisted_6 = {
  key: 0,
  src: _imports_0
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1
}
const _hoisted_8 = {
  key: 1,
  class: "invoice-popup__title"
}
const _hoisted_9 = {
  key: 2,
  class: "invoice-popup__message"
}
const _hoisted_10 = { class: "invoice-popup__button" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("登入/註冊")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("前往開通")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("關閉")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_invoice_button = _resolveComponent("invoice-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isValid(_ctx.modelValue.type))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.modelValue.type === 'success')
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isValid(_ctx.modelValue.title))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.modelValue.title), 1))
          : _createCommentVNode("", true),
        (_ctx.isValid(_ctx.modelValue.message))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.modelValue.message), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.isValid(_ctx.modelValue.isLogin))
            ? (_openBlock(), _createBlock(_component_invoice_button, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emit('login')))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isValid(_ctx.modelValue.isWallet))
            ? (_openBlock(), _createBlock(_component_invoice_button, {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emit('wallet')))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isValid(_ctx.modelValue.isClose))
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "invoice-popup__close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emit('close')))
            }, "關閉"))
          : _createCommentVNode("", true),
        (_ctx.isValid(_ctx.modelValue.isColorClose))
          ? (_openBlock(), _createBlock(_component_invoice_button, {
              key: 4,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emit('close')))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}